import { useTRPC } from "../../../../trpc/client";
import { useQueryClient, useMutation } from "@tanstack/react-query";

export function useSetPartialPaymentActivation(
  onSuccess: () => void,
  onError: (error: unknown) => void
) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.invoices.setPartialPaymentActivation.mutationOptions(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: trpc.invoices.list.queryKey(),
      });
      onSuccess();
    },
    onError,
  });

  return {
    setPartialPaymentActivation: mutation.mutate,
    isPending: mutation.isPending,
  };
}
